// Cache in-flight requests as well as loaded bundles. Only the latest choice
// may update the interface; failed bundles can be retried without losing work.
export function createLocaleLoader(loaders, setBusy = () => {}) {
  const cached = new Map();
  let revision = 0;
  return async (target, apply) => {
    const current = ++revision;
    setBusy(true);
    try {
      let pending = cached.get(target);
      if (!pending) {
        pending = Promise.resolve().then(() => loaders[target]());
        cached.set(target, pending);
        pending.catch(() => {
          if (cached.get(target) === pending) cached.delete(target);
        });
      }
      const resources = await pending;
      if (current !== revision) return false;
      await apply(resources);
      return true;
    } finally {
      if (current === revision) setBusy(false);
    }
  };
}
